import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {View, Text, TouchableOpacity} from 'react-native';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {CertificateInfo} from '../../../../../shared/models/api/eCertificatesResponsePayload';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {TruTable} from '../../TruTable';
import {useInfoTabMobileStyles} from './InfoTabMobile.style';
import {formatDate} from '../../../../../shared/utils/formatDate';
import {numberFormatToRub} from '../../../../../shared/utils/numberFormatToRub';
import {ScrollViewMapProps} from '../../../../../shared/components/yaMap';
import {eCertificatesSlice} from '../../../../../redux/reducers/eCertificates';
import {sellersSelector} from '../../../../../redux/selectors/eCertificates';
import {SellersGeoMap} from '../../SellersGeoMap';
import {TruCard} from '../TruCard';

interface InfoTabProps {
  certificate?: CertificateInfo | null;
  activeTruIds?: number[];
  mapProps: ScrollViewMapProps;
  setActiveTruIds: React.Dispatch<React.SetStateAction<number[] | undefined>>;
  onTruClick: (truId: number, refToScroll: React.RefObject<View>) => void;
}

export function InfoTabMobile({certificate, activeTruIds, setActiveTruIds, onTruClick, mapProps}: InfoTabProps) {
  const styles = useInfoTabMobileStyles();
  const sellers = useSelector(sellersSelector());
  // const dispatch = useDispatch();
  const mapContainerRef = useRef<View>(null);
  const {templateName, certificateNumber, statusName, actualAmount, startDate, endDate, truBalance, organizationName} =
    certificate ?? {};

  // useEffect(() => {
  //   setActiveTruIds(undefined);
  //   dispatch(eCertificatesSlice.actions.setSellers([]));
  //   dispatch(eCertificatesSlice.actions.setDepartment(null));
  // }, []);

  return (
    <LoadableContent loading={!certificate}>
      <View style={styles.cardInfo}>
        <View style={styles.cardRow}>
          <Text style={styles.cardTitle}>Рег. номер</Text>
          <Text style={styles.cardText}>{certificateNumber}</Text>
        </View>

        <View style={styles.cardRow}>
          <Text style={styles.cardTitle}>Наименование</Text>
          <Text style={styles.cardText}>{templateName}</Text>
        </View>

        <View style={[styles.cardRow, {flexDirection: 'row', width: '100%'}]}>
          <View style={[{flexBasis: '50%'}]}>
            <Text style={styles.cardTitle}>Дата начала</Text>
            <Text style={styles.cardText}>{startDate ? formatDate(startDate) : '-'}</Text>
          </View>

          <View style={{flexBasis: '50%'}}>
            <Text style={styles.cardTitle}>Дата окончания</Text>
            <Text style={styles.cardText}>{endDate ? formatDate(endDate) : '-'}</Text>
          </View>
        </View>

        <View style={[styles.cardRow, {flexDirection: 'row', width: '100%'}]}>
          <View style={{flexBasis: '50%'}}>
            <Text style={styles.cardTitle}>Статус</Text>
            <Text style={styles.cardPrimaryText}>{statusName}</Text>
          </View>

          {certificate && certificate.certificateTypeCode !== 'ECTP0001' && (
            <View style={{flexBasis: '50%'}}>
              <Text style={styles.cardTitle}>Доступный остаток</Text>
              <Text style={styles.balance}>{numberFormatToRub(actualAmount ?? 0)}</Text>
            </View>
          )}
        </View>

        <Text style={styles.cardTitle}>Наименование организации, предоставляющей сертификат</Text>
        <Text style={styles.cardText}>{organizationName}</Text>
      </View>

      <Text style={styles.subtitle}>Товары/работы/услуги возможные к приобретению по данному сертификату</Text>

      <View style={styles.truCardList}>
        <CustomScrollView style={{maxHeight: 500}}>
          {truBalance?.length ? (
            <>
              {/* <Text>Наименование</Text> */}
              {truBalance.map(({truId, truName}) => (
                <View key={truId} style={styles.truRow}>
                  <Text style={styles.truName}>{truName}</Text>
                </View>
              ))}
            </>
          ) : null}
        </CustomScrollView>
      </View>

      <View ref={mapContainerRef}>
        <SellersGeoMap sellers={sellers} setActiveTruIds={setActiveTruIds} mapProps={mapProps} />
      </View>
    </LoadableContent>
  );
}
